###
This directive provides some functionality specific only to the Google Analytics
Reporting integration and thus not appropriate for the integrationDirective.

When set as an attribute on a button, this directive does two things:

- If the metrics and dimensions have not been set on a connection, it will only
invoke ``successCallback`` if this combination of metrics and dimensions is valid.
- If the metrics and dimensions have not been set on a connection, it will set a
``metrics_and_dimensions_set`` property on the connection. (This is how we know
whether the metrics and dimensions have been set previously.)
###
angular.module("rjmNg.common.directives").directive "validateGoogleAnalytics", [
  "GoogleAnalyticsReportValidator"
  "app"
  "notification"
  (
    GoogleAnalyticsReportValidator
    app
    notification
  ) ->
    require: "^?rjmUi"
    restrict: "A"
    scope:
      connection: "=validateGAConnection"
      notificationScope: "@validateGANotificationScope"
      successCallback: "&validateGASuccessCallback"
    link: (scope, element, attributes, rjmUi) ->

      isNewConnection = not Number(scope.connection?.properties?.metrics_and_dimensions_set)

      validatorInstance = GoogleAnalyticsReportValidator
        .getValidatorInstance(app.getClientId(), "dashapp")

      validate = () ->
        if isNewConnection
          notification.clear(scope.notificationScope)
          rjmUi?.blockUi("google-analytics-validator", true)
          validatorInstance(scope.connection).then (state) ->
            unless state is GoogleAnalyticsReportValidator.STATES.VALID or
              state is GoogleAnalyticsReportValidator.STATES.NO_DATA
                notification.error "Invalid metrics and dimensions.", "There is a
                  problem with the combination of metrics and dimensions you
                  entered.", scope.notificationScope
            else
              scope.connection.properties.metrics_and_dimensions_set = "1"
              scope.successCallback()
          .finally () ->
            rjmUi?.blockUi("google-analytics-validator", false)

        else
          scope.successCallback()

      element.on "click", () ->
        scope.$applyAsync(validate)

]
